import cs from 'classnames';
import React, { useState } from 'react';
import { useInitialState } from '../../../contexts/InitialStateContext';
import { Template } from '../../../domain/entities/template';
import { Loader } from '../../Loader/Loader';
import { templatePreviewModalDataHooks } from '../TemplatePreviewModal.dataHooks';
import s from './TemplateDemoPreview.scss';

type Props = {
  template: Template;
};

export const TemplateDemoPreview: React.FC<Props> = ({ template }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { baseUrl } = useInitialState();

  return (
    <div
      data-hook={templatePreviewModalDataHooks.templateDemoPreview()}
      className={cs(s.demoDisplay)}
    >
      {isLoading && (
        <div className={s.loader}>
          <Loader />
        </div>
      )}
      <iframe
        onLoad={() => setIsLoading(false)}
        className={s.iframe}
        src={`${baseUrl}/api/preview/${template.metaSiteId}/mobile`}
        title={template.title}
        width="100%"
        height="100%"
        data-hook={templatePreviewModalDataHooks.templateDemoPreviewIframe()}
      />
    </div>
  );
};
